import styled from 'styled-components';

export const StyledArrowIcon = styled.div`
    width: ${({width}) => (width ? width : '10px')};
    height: ${({height}) => (height ? height  : '10px')};;
    background-image: url(${({imgUrl}) => (imgUrl)});
    background-repeat: no-repeat;
    background-size: contain;
    background-color:'#EBEDED';
    transform: ${({isOpen}) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 1s,
`;
